import React, { useEffect} from 'react';
import {useDispatch, useSelector } from 'react-redux';
import './SupplierStyle.css';
import { getSuppliers } from '../../redux/actions/Supplier/SupplierAction';

const SupplierList = () =>{
    //const [supplier, setSupplier] = useState(null);
    const suppliers = useSelector((state) => state.suppliers);
    const dispatch = useDispatch();

    useEffect(()=> {dispatch(getSuppliers());},[] );

    return(
        <div className='SearchPage'>
            <div className='supplier-table'>
                <table className="table table-success table-striped">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Name</th>
                            <th scope="col">Phone Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {suppliers.map((val, key) => {
                            return(
                                <tr key={key}>
                                    <th scope="row">{val.supplierId}</th>
                                    <td>{val.supplierName}</td>
                                    <td>{val.supplierPhoneNumber}</td>
                                </tr>
                            );
                        })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SupplierList;